import * as Yup from 'yup'

export const passwordSchema = Yup.string()
  .min(8, 'Must be at least 8 characters')
  .required('Required')

export const emailSchema = Yup.string()
  .email('Must be valid email')
  .required('Required')

export const deliveryInfoAddress2Schema = Yup.string()
  .label('Apt./Suite no.')
  .trim()
  .max(255)
  .default('')

export const deliveryInfoNotesSchema = Yup.string()
  .label('Delivery Instructions')
  .trim()
  .max(300)
  .default('')
